import { SANITY_MEDIA_FILES } from '../../../ahm-constants/ui';
import HealthWidget from '../../home/components/health-widget';

export default {
  meta: {
    description:
      'Comparing health insurance is a breeze with ahm. Discover different health cover options for singles, couples, families and single parents today.',
    title: 'Join ahm - Browse Policies & Plans',
  },
  sections: {
    'hero-banner': {
      footer: <HealthWidget variant="inline" />,
      subtitle: [
        {
          _type: 'block',
          children: [
            {
              _key: '0',
              _type: 'span',
              text: 'People are complex creatures, but hey, that’s why we like you. So, when it comes to our thing (the insurance thing), we’re here to support with simple, smart, and affordable insurance.',
            },
          ],
          style: 'normal',
        },
      ],
      title: 'Health insurance for people things',
      video: SANITY_MEDIA_FILES.HOME_VIDEO_SRC,
    },
  },
};
